// extracted by mini-css-extract-plugin
export default {"TableInfo":"TableInfo_TableInfo__BkrdU","InfoType":"TableInfo_InfoType__y72Bh"};